if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"ai_interview_flowup_0_1_0","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(1(7(05|14|58)|053|47|504|603)|2(089|266|564)|3(149|201|702|732)|4(264|626|881|934)|54(83|96)|6(293|381|903|920)|7(341|487|83)|8122|9284)$/.test(chunkId)},
		rootOutputDir: "../../",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}